export type OrganizationTypeId = 'HVS' | 'CQQL' | 'KHDN';

export interface Combobox {
  id: string;
  name: string;
}

/**
 * map lại thông tin của Phân loại tổ chức
 */
export const orgIds = {
  system: 'HVS',
  client: 'KHDN',
  govAgency: 'CQQL',
};

export const organizationTypes: Combobox[] = [
  { id: orgIds.system, name: 'Cơ quan chủ quản' },
  { id: orgIds.client, name: 'Khách hàng' },
  { id: orgIds.govAgency, name: 'Cơ quan quản lý' },
];

/**
 * Đơn vị có phân loại "Khách hàng" hay không, xét theo LOẠI ĐƠN VỊ.
 *
 * Trước đây nhiều chỗ nhận biết bằng cách cắt 2 ký tự đầu của mã CĐS và so với 'KH'. Cách đó vỡ
 * ngay khi KIOS đổi bộ mã: mã khách hàng giờ là `HSKD-*`, nên mọi kiểm tra kiểu đó âm thầm trả về
 * false — đúng lỗi "tab Gán vai trò cho chọn mọi khách hàng dù đã chọn đơn vị". Loại đơn vị là dữ
 * liệu có sẵn và không phụ thuộc cách đánh mã, nên xét theo nó.
 *
 * Chấp nhận CẢ HAI dạng: giá trị API ('client') và giá trị hiển thị ('KHDN') — vài màn đã đổi sang
 * dạng hiển thị bằng convertOrgType() trước khi dùng.
 */
export const isClientOrgType = (orgType?: string | null): boolean =>
  orgType === 'client' || orgType === orgIds.client;

export interface JobTitle extends Combobox {
  organizationTypeId: OrganizationTypeId;
}

export const jobTitles: JobTitle[] = [
  {
    id: 'HVS-GDOC',
    name: 'Giám đốc dự án DX HVS',
    organizationTypeId: 'HVS',
  },
  {
    id: 'HVS-IT',
    name: 'Nhân viên IT HVS',
    organizationTypeId: 'HVS',
  },
  {
    id: 'HVS-DDUONG',
    name: 'Nhân viên dinh dưỡng HVS',
    organizationTypeId: 'HVS',
  },
  {
    id: 'HVS-BHANG',
    name: 'Nhân viên báo hàng HVS',
    organizationTypeId: 'HVS',
  },
  {
    id: 'HVS-HTRO',
    name: 'Nhân viên hỗ trợ khách hàng HVS',
    organizationTypeId: 'HVS',
  },
  // {
  //   id: "Root admin",
  //   name: "Người dùng Root",
  //   organizationTypeId: "HVS",
  // },
  {
    id: 'KH-KTOAN',
    name: 'Kế toán khách hàng',
    organizationTypeId: 'KHDN',
  },
  {
    id: 'KH-LDAO',
    name: 'Lãnh đạo khách hàng / Hiệu trưởng',
    organizationTypeId: 'KHDN',
  },
  {
    id: 'KH-QLSAN',
    name: 'Quản lý suất ăn của khách hàng / Giáo viên',
    organizationTypeId: 'KHDN',
  },
  {
    id: 'KH-NVIEN',
    name: 'Nhân viên khách hàng',
    organizationTypeId: 'KHDN',
  },
  {
    // Tách khỏi "Nhân viên khách hàng / Phụ huynh" (docx §4 + xlsx sheet 01 r16). Chức vụ MỚI.
    id: 'KH-PHOTHONG',
    name: 'Người dùng phổ thông, phụ huynh',
    organizationTypeId: 'KHDN',
  },
  {
    id: 'CQQL-CVIEN',
    name: 'Cán bộ ATTP / Chuyên viên dinh dưỡng, thực phẩm',
    organizationTypeId: 'CQQL',
  },
  {
    id: 'CQQL-LDAO',
    name: 'Lãnh đạo CQQL ATTP',
    organizationTypeId: 'CQQL',
  },
];

export const genders: Combobox[] = [
  { id: 'MALE', name: 'Nam' },
  { id: 'FEMALE', name: 'Nữ' },
  { id: 'OTHERS', name: 'Khác' },
];
